import React, { useState, useRef, useEffect } from "react";
import ReComments from "../../ReComments/index";
import TextAreaUpdate from "../../Comments/CommentTextUpdate/index";
import CommentRenderTwo from "../../Comments/CommentRenderTwo/index";
import commentContext from "../../contextApi/index";

import { loadDetailPost } from "../../../../../../redux/modules/postSlice";
import { DetailLine } from "../../../common/commonStyle";

import { CommentItem } from "./style";
import { useDispatch } from "react-redux";

function CommentsRender({ post, comment, textareaRef }) {
  const commentRef = useRef(null);
  const [commentMore, setCommentMore] = useState(false); // 댓글 더보기 토글
  const [visible, setVisible] = useState(true);

  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(loadDetailPost(post.boardId));
  }, [dispatch, post.boardId]);

  const setCommentMorePropsFunc = () => {
    setCommentMore((prev) => !prev);
  };
  const setVisiblePropsFunc = () => {
    setVisible((prev) => !prev);
  };

  // 댓글 렌더링
  return visible ? (
    <commentContext.Provider
      value={{ commentMore, setVisiblePropsFunc, setCommentMorePropsFunc }}
    >
      <CommentItem className="comments" ref={commentRef}>
        <CommentRenderTwo
          post={post}
          comment={comment}
          render="CommentsRender"
          textareaRef={textareaRef}
        />

        <DetailLine />
        {comment?.recommentCount > 0 && (
          <>
            {comment.recomment?.map((recom) => (
              <ReComments post={post} comment={comment} recomment={recom} />
            ))}
          </>
        )}
      </CommentItem>
    </commentContext.Provider>
  ) : (
    <TextAreaUpdate
      post={post}
      comment={comment}
      setCommentMorePropsFunc={setCommentMorePropsFunc}
      setVisiblePropsFunc={setVisiblePropsFunc}
    />
  );
}

export default CommentsRender;
